import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";
import { useApp } from "../context/AppContext";
import { api, useFetch } from "../lib/api";
import { timeAgo } from "../lib/fmt";
import { PageHeader, Loading, Empty } from "../components/bits";

export default function Notifications() {
  const { sp, refreshBadges } = useApp();
  const nav = useNavigate();
  const { data } = useFetch(sp("/notifications"));
  useEffect(() => {
    if (data) api.post(sp("/notifications/read")).then(refreshBadges);
  }, [data, sp, refreshBadges]);
  return (
    <div data-testid="notifications-page">
      <PageHeader title="Notifications" back="/" />
      {!data ? <Loading /> : data.length === 0 ? <Empty icon={Bell} text="Aucune notification." /> : (
        <div className="space-y-2">
          {data.map((n) => (
            <button key={n.id} onClick={() => nav(n.url)} data-testid="notification-item" className={`card tap flex w-full items-start gap-3 p-4 text-left ${n.read ? "" : "border-teal-200 bg-teal-50"}`}>
              {!n.read && <span className="mt-1.5 h-2 w-2 shrink-0 rounded-full bg-teal-600" />}
              <div className="min-w-0 flex-1"><div className="font-bold">{n.title}</div><div className="text-sm text-slate-600">{n.body}</div></div>
              <span className="shrink-0 text-[11px] text-slate-400">{timeAgo(n.created_at)}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
